<template>
  <div class="container-fluid min-vh-100 d-flex flex-column bg-blue py-4 overflow-hidden">
    <div class="row g-3 text-center">

      <div class="col-6">
        <a href="/collection/list/" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/COLECOES.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/product/rank/product_views_summaries.monthly_views" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/CARDS.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/producttcg/list/" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/PRODUTOS_TCG.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/classifieds" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/CLASSIFICADOS.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/products-cards-bra-center" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/BRA_CENTER.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/my-store/besaler" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/VIRE_UM_LOJISTA.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/league/lorcana" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/LIGAS_BRA.webp" class="w-75" alt="">
        </a>
      </div>

      <div class="col-6">
        <a href="/my-account" class="text-decoration-none text-dark">
          <img src="/img/ICONES-MOBILE/ACESSE_SUA_CONTA.webp" class="w-75" alt="">
        </a>
      </div>

    </div>

    <div class="row mt-5 mb-4">
      <hr class="text-white">
    </div>

    <div class="row text-center">
      <div class="col-12">
        <a href="/auth/login" class="btn btn-danger fw-bold" style="width: 88%">ENTRE</a>
      </div>
    </div>

    <div class="row text-center">
      <div class="col-12">
        <button class="btn bg-blue fw-bold">CADASTRE-SE</button>
      </div>
    </div>

    <div class="row">
      <div style="display: flex; gap: 10px; justify-content: center;">
        <img class="social-icon" 
          src="/img/REDES-LOGO/youtube.png" 
          onmouseover="this.src='/img/REDES-LOGO/YOUTUBE_02.png'" 
          onmouseout="this.src='/img/REDES-LOGO/youtube.png '" 
        />
        
        <img class="social-icon rounded-circle ms-2"
          src="/img/REDES-LOGO/instagram.png"
          onmouseover="this.src='/img/REDES-LOGO/INSTAGRAM_02.png'"
          onmouseout="this.src='/img/REDES-LOGO/instagram.png'" 
        />
        
        <img class="ms-2 social-icon" 
          src="/img/REDES-LOGO/facebook.png"
          onmouseover="this.src='/img/REDES-LOGO/FACEBOOK_02.png'" 
          onmouseout="this.src='/img/REDES-LOGO/facebook.png'"
        />
      
        <img class="ms-2 social-icon" 
          src="/img/REDES-LOGO/tiktok.png"
          onmouseover="this.src='/img/REDES-LOGO/TIK_TOK_02.png'" 
          onmouseout="this.src='/img/REDES-LOGO/tiktok.png'"
        />
        
        <img class="ms-2 social-icon" 
          src="/img/REDES-LOGO/twitter.png"
          onmouseover="this.src='/img/REDES-LOGO/X_TWITTER_02.png'" 
          onmouseout="this.src='/img/REDES-LOGO/twitter.png'"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: { },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  computed: {
    
  },
  beforeCreate() {
    
  },
};
</script>

<style>
.social-icon {
  width: 45px;
}
</style>